module.exports = __webpack_public_path__ + "static/media/ROSE.56904df7.png";